import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete3",
  "use": "icon-delete3-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-delete3\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M15 4v2h-2v9H3V6H1V4h14zm-4 2H5v7h6V6zm0-5v2H5V1h6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol